import React from 'react'
import NumberFormat from './NumberFormat'
import ReduceBigNumbers from './ReduceBigNumbers'

function ChipsCard( data ) {

    return(
        <div className="buyChips">
            <div className='teaserWrapper'>
                <div className="buyChips_teaser"><h4>Coming soon</h4></div>
                <div className="buyChipsImg_dissabled" style={{ backgroundImage: "url(images/getChips/" + data.image +".png)", }}></div>
            </div>
            <div className="buyChips_infoWrapper">
                <div className="buyChips_infoWrapper_textWrapper">
                    <h3>{ ReduceBigNumbers( data.amount )}</h3>
                    <div className="buyChips_chips"><p>chips</p></div>
                </div>
                <button className="purple_button_dissabled">
                    <NumberFormat amount={ data.cost } type='currency'/> 
                 </button>
            </div>
        </div>
    )
}

export default ChipsCard;